import React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { GradebookActivity, GradeParent, IGradesProps, IGradesState, MyGrades } from '../../models/pages/mygrades';
import moment from 'moment';
import 'moment/locale/en-gb';
import 'moment/locale/tr';
import 'moment/locale/ar';
import { Common } from '../../core/common';
import Translator from '../../core/i18n';
import { IAction, IAppState } from '../../models/action/core';
import { GetMyGradebook } from '../../store/actions/gradebook';
import { Log } from 'ng2-logger';
import { ActivityTypeEnums } from '../../models/enums/ActivityType';
import { Redirect } from 'react-router-dom';
import { GradebookStatus } from '../../models/enums/gradeBook';
import Tooltip from '../../components/tooltip/main';

const T = Translator.create();
const _logger = Log.create('Gradebook - main.tsx');
let _common: Common;
const date = new Date()

if (T.i18next.language === 'tr') {
     moment.locale('tr');
} else if (T.i18next.language === 'en') {
     moment.locale('en');
}
else if (T.i18next.language === 'ar') {
     moment.locale('ar');
}

class CMyGradesPage extends React.Component<IGradesProps, IGradesState> {

     constructor(props: IGradesProps) {
          super(props);
          _common = new Common();
     }
     state = {
          redirect: false,
          redirectUrl: ""
     }
     componentDidMount(): void {
          this.props.dispatch(GetMyGradebook());
     }

     redirectActivity = (event: any) => {
          if (event && event.currentTarget) {
               this.setState({ redirect: true, redirectUrl: event.currentTarget.getAttribute('data-redirectLink') });
          }
     }

     renderActivityCards = (activity: GradebookActivity, classId: string, courseId: string) => {
          let activity_subText = activity.activityType !== ActivityTypeEnums.Course ? activity.infoNote : T.t("r_opinion")
          let gradePointText_className;

          switch (activity.status){
               case GradebookStatus.Failed:
                    gradePointText_className = "grade-point-text danger";
                    break;
               case GradebookStatus.NotResulted:
                    gradePointText_className = "grade-point-text warning";
                    break;
               case GradebookStatus.Passed:
                    gradePointText_className = "grade-point-text success";
                    break;
               default:
                    gradePointText_className = "grade-point-text";
                    break;
          }
          return (
               <div className="activity">
                    <div className="activity-details">
                         <div className="activity-icon ">
                              <img src={_common.GetActivityTypeIcons(_common.ActivityValues[activity.activityType])} alt="" />
                         </div>
                         <div className="activity-names">

                         <Tooltip data= {activity.activityName} position='top'>
                                        <span
                                             style={{ cursor: 'pointer' }}
                                             data-redirectLink={'u/course?classId=' + classId + '&activityId=' + courseId + '&type=1' + '&actid=' + activity.activityId}
                                             onClick={this.redirectActivity}
                                             className="activity-name d-inline-block text-truncate">{activity.activityName}
                                        </span>
                                        </Tooltip>
                              <div className="activity-subtext">{activity_subText} </div>
                         </div>
                    </div>

                    <div className="activity-grade-details">
                         <span className="status">{T.t("r_gradebook_status_" + activity.status)}</span>
                         <span className="status">{T.t("r_gradebook_percentage").replace("{0}", activity.percentage)}</span>
                         <span className="grade-point">
                              <span className={gradePointText_className}>
                                   {T.t("r_gradebook_score").replace("{0}", activity.score).replace("{1}", "100")}
                              </span>
                         </span>
                    </div>
               </div>
          )
     }

     sortGrades = (activeGrades: any) => {
          if (!activeGrades) {
               return [];
          }

          // myGrades dizisinin bir kopyasını oluşturun
          let gradesCopy = [...activeGrades];

          // Diziyi sıralayın
          gradesCopy.sort((a: MyGrades, b: MyGrades) => {
               // Her iki dersin toplam aktivite sayısını hesaplayın
               const aActivityCount = a.parents.reduce((count, parent) => count + parent.activities.length, 0);
               const bActivityCount = b.parents.reduce((count, parent) => count + parent.activities.length, 0);

               // Aktivite sayısına göre karşılaştırma yapın
               if (aActivityCount > 0 && bActivityCount === 0) {
                    return -1; // a üstte olacak
               } else if (aActivityCount === 0 && bActivityCount > 0) {
                    return 1; // b üstte olacak
               } else {
                    // Eğer her ikisinde de aktivite varsa veya yoksa, alfabetik olarak sıralayın
                    return a.courseName.localeCompare(b.courseName);
               }
          });

          return gradesCopy;
     };

     showAllActivities = (index: number) => {
          return (
              <div className='mx-auto w-100 d-flex justify-content-center text-center'>
                  <button
                      className='show-more'
                      type='button'
                      data-toggle='collapse'
                      data-target={`#gradeCollapseMoreActivity${index + 1}`}
                      aria-expanded="false"
                      aria-controls={`gradeCollapseMoreActivity${index + 1}`}
                      onClick={(e) => {
                          const target = e.currentTarget;
                          const isExpanded = target.getAttribute('aria-expanded') === 'true';
                          const newState = isExpanded ? 'false' : 'true';
                          target.setAttribute('aria-expanded', newState);

                          // Toggle the collapsed class on the button
                          target.classList.toggle('collapsed');

                          // Update the icon class based on the new state
                          const icon = target.querySelector('i');
                          if (icon) {
                              icon.className = `arrow ${newState === 'true' ? 'up' : 'down'}`;
                          }

                          // Update the button text
                          const textSpan = target.querySelector('span');
                          if (textSpan) {
                              textSpan.textContent = T.t(newState === 'true' ? "r_menu_course_hideAll" : "r_menu_course_viewAll");
                          }
                      }}
                  >
                      <span>{T.t("r_menu_course_viewAll")}</span>
                      <i className="arrow down"></i>
                  </button>
              </div>
          );
      }
     renderActivityContents = (activities: any, index: number, classId: string, courseId: string) => {
          let activityContents;
          if (activities && activities.length > 0) {
               if (activities.length > 4) {
                    activityContents = (
                         <>
                              {activities.slice(0, 4).map((act: GradebookActivity) => (
                                   this.renderActivityCards(act, classId, courseId)
                              ))}
                              <div className=" collapse " id={`gradeCollapseMoreActivity${index + 1}`}>
                                   {
                                        activities.slice(4, activities.length).map((act: GradebookActivity) => (
                                             this.renderActivityCards(act, classId, courseId)
                                        ))
                                   }
                              </div>
                              {this.showAllActivities(index)}
                         </>
                    );
               } else {
                    activityContents = activities.map((act: GradebookActivity) => (
                         this.renderActivityCards(act, classId, courseId)
                    ));
               }
          }
          return activityContents;
     }

     renderCourseCardInfo = (course: MyGrades, index: number) => {
          let courseActivityCount = 0;
          if (course.parents.length > 0) {
               course.parents.forEach(parent => {
                    courseActivityCount += parent.activities.length;
               });
          }

          return (
               <div className="col-12 mt-4">
                    <div className="grade-card">
                         <button className="header" type='button' data-toggle="collapse" data-target={`#gradeCollapse${index + 1}`} aria-expanded="false" aria-controls={`gradeCollapse${index + 1}`}>
                              <div className="titles">
                                   <span className="faculty">{course.programName}</span>
                                   <div className='d-flex align-items-center gap-1 '>
                                   <Tooltip data={course.courseName} position='top'>
                                        <span className="course d-inline-block text-truncate">{course.courseName}</span>
                                        </Tooltip>
                                        <span className="activity-count badge badge-pill badge-light mb-1 py-1 px-2">{courseActivityCount}</span>
                                   </div>
                              </div>
                              <div className="total-grade">
                              <Tooltip data={T.t('r_activity_exam_exam_type_1')} position='top'>
                                   <span className={course.total > 0 ? "total-grade-text success" : "total-grade-text "}>{course.total > 0 ? course.total : "--"}</span>
                              </Tooltip>

                              </div>
                         </button>
                         <div className="body collapse show" id={`gradeCollapse${index + 1}`}>
                              {course.parents && course.parents.length > 0 ?
                                   course.parents.map((parent: GradeParent) => (
                                        <>
                                             {this.renderActivityContents(parent.activities, index, course.classId, course.courseId)}
                                        </>
                                   ))
                                   :
                                   <div className="col-12 mt-4">
                                        <div className="not_found">
                                             <img src={_common.GetDefaultImages('_not_found')} alt="" />
                                             <span className='subheading2'>{T.t('r_not_grade_chart')}</span>
                                        </div>
                                   </div>
                              }
                         </div>
                    </div>
               </div>

          )
     }

     activeCourses = () => {
          let activeCourses = null;
          if (this.props.userHomeMyCourses && this.props.userHomeMyCourses.length > 0) {
               activeCourses = this.props.userHomeMyCourses.filter((f: any) => {
                    const isActive = f.activeStatus === 1;
                    let isWithinDateRange = false;
                    let dateCondition = false;

                    dateCondition = f.termId === null || f.courseEndDate === null;

                    isWithinDateRange = this.isWithinDate(f.courseEndDate);
                    const isCourseActive = isActive && (dateCondition || isWithinDateRange);
                    return isCourseActive;
               })

          }
          return activeCourses;
     }

     isWithinDate = (date: any) => {
          let nowDate = moment().format("yyyy-MM-DDTHH:mm:ss");
          let isWithinDateRange = false;
          if (date) {
               isWithinDateRange = date.toString() >= nowDate;
          }
          return isWithinDateRange;
     }

     public render() {
          let activeCourses = this.activeCourses();
          let activeGrades: MyGrades[] = [];

          activeCourses.forEach((course: any) => {
               let findCourse = this.props.myGrades?.find(grade => grade.courseId === course.courseId)
               if (findCourse) {
                    activeGrades.push(findCourse);
               }
          });
          let courseCount = activeGrades.length > 0 ? activeGrades.length : 0;
          let sortedActiveGrades = this.sortGrades(activeGrades);

          if (this.state.redirect) {
               return <Redirect push={true} to={window.appSettings.DEFAULT_URL + '/' + this.state.redirectUrl} />;
          }

          return (
               <div className="container pd-top-30 ">
                    <div className="row ">
                         <div className="col-md-4 col-12 d-flex align-items-baseline gap-1">
                              <h6 className="m-pl-2 mb-md-0 heading3 fw-500">{T.t('r_menu_grade_chart')}</h6>
                              <span className='grade-activity-total-count'>{T.t("r_gradebook_course_count").replace("{0}", courseCount)}</span>
                         </div>

                    </div>
                    <div className="row">
                         {/* not çizelgesi oluşturulmamış ise */}
                         {
                              sortedActiveGrades && sortedActiveGrades.length > 0 &&
                              <>
                                   {sortedActiveGrades.map((course: MyGrades, index: number) => (
                                        this.renderCourseCardInfo(course, index)
                                   ))}

                              </>
                         }
                    </div>

               </div>
          );
     }
}

const mapStateToProps = (state: IAppState, ownProps: IGradesProps): IGradesProps => {
     if (!state) {
          return ownProps;
     }

     const newProps: IGradesProps = Object.assign({}, ownProps, {
          myGrades: state.gradebook.myGrades,
          userHomeMyCourses: state.userHomePage.userHomeMyCourses
     });
     return newProps;
};

const areStatesEqual = (next: IAppState, prev: IAppState) => {
     const ret = next.gradebook.myGrades === prev.gradebook.myGrades &&
          next.userHomePage.userHomeMyCourses === prev.userHomePage.userHomeMyCourses
     return ret;
};
const dispatchProps = (dispatch: Dispatch<IAction>) => {
     return {
          dispatch
     };
};

const MyGradesPage = connect(
     mapStateToProps,
     dispatchProps,
     null,
     {
          areStatesEqual
     }
)(CMyGradesPage);

export default MyGradesPage;
